// @ts-nocheck

import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

import { getRedirectUrl, RedirectServices } from '../../../../config/urls';
import { querySelector } from '../../../../DOMElements';
import useRouter from '../../../../hooks/useRouter';
import { __ } from '../../../../i18n/l10n';
import { isGridsHistory } from '../../utils/routes';
import HelpCss from '../buttons/HelpButton';

const GlobalStyle = createGlobalStyle`
html.app-desktop body.grids {
  #above-content {
    background: ${({ theme }) => theme.grids.colors.darkgrey3};
    box-shadow: none;
    z-index: 12;
    border-bottom: none;
    height: auto;
  }

  #secondary-nav ul li:not(.grid-top-nav),
  #secondary-nav #section-title {
    display: none;
  }

  #secondary-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    padding: 0;

    ul {
      width: 100%;
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      float: none;
      margin: 0;

      li.grid-top-nav {
        float: none;
        display: flex;
        justify-content: center;
        align-items: stretch;
        margin: 0;

        button,
        a {
          font-family: BettingPoliticaBold, sans-serif;
          color: ${({ theme }) => theme.grids.colors.middlegrey3};
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.8em 0.8em 1.2em;
          border-radius: 0;
          margin: 0 1em;
          position: relative;
          outline: 0;

          &[data-ishightlight=true] {
            color: #fff;
          }
        }
      }
    }
  }

  #main-nav ul.main-nav-list li a,
  #main-nav ul.main-nav-list li.focus a,
  #main-nav ul.main-nav-list li button,
  #main-nav ul.main-nav-list li.focus button {
    padding-bottom: 8px;
  }

  @media screen and (max-width: 1020px) {
    #secondary-nav {
      padding: 0;
      ul {
        background: none;
        height: auto;
      }
      ul li {
        float: left;
        border-top: none;
        border-bottom: none;
      }
    }
  }
}
`;

const HelpButton = styled.span`
  ${HelpCss}
  margin: 0;
`;

const FlexStart = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Flex = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: BettingPoliticaBold, sans-serif;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
`;

const Title = styled(Flex)`
  text-transform: uppercase;
  min-width: 110px;
  font-size: 1.2em;
`;

const StyledLink = styled(Link)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const StyledButton = styled.button`
  background-color: transparent;
  border: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const BorderRed = styled.span`
  display: inline-block;
  background: ${({ theme }) => theme.grids.colors.redlight};
  height: 3px;
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
`;

const nodeElm = querySelector('#secondary-nav');
const domElm = querySelector('ul', nodeElm);

const GridsDesktopSubMenu = ({ openExternalLink }) => {
  const { location } = useRouter();
  const isHistory = isGridsHistory(location.pathname);

  const onClickRules = useCallback(() => {
    openExternalLink(getRedirectUrl(RedirectServices.GRIDS_RULES));
  }, [openExternalLink]);

  return domElm
    ? createPortal(
        <>
          <GlobalStyle />
          <FlexStart className="grid-top-nav">
            <Title>{__('grids')}</Title>
            <Flex>
              <StyledLink to="/grilles" data-ishightlight={!isHistory}>
                {__('Grids Home')}
                {!isHistory && <BorderRed />}
              </StyledLink>
            </Flex>
            <Flex>
              <StyledLink to="/grilles/history" data-ishightlight={isHistory}>
                {__('My grids')}
                {isHistory && <BorderRed />}
              </StyledLink>
            </Flex>
            <Flex>
              <StyledButton onClick={onClickRules}>{__('Rules')}</StyledButton>
            </Flex>
          </FlexStart>
          <li className="grid-top-nav">
            <StyledLink
              to={{
                hash: '#help',
                state: { modal: true },
              }}
            >
              <Flex>
                {__('how it works')}
                <HelpButton>?</HelpButton>
              </Flex>
            </StyledLink>
          </li>
        </>,
        domElm,
      )
    : null;
};

export default GridsDesktopSubMenu;
